/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
import { Shape, ExtrudeGeometry, Mesh } from "three";
import { UVMapFace } from "@rendering/vortex-core";
function normalizeUvs(geometry, faceId, width, height) {
  const faceIndex = faceId * 2;
  // Left triangle
  for (let i = 0; i < 3; i++) {
    geometry.faceVertexUvs[0][faceIndex][i].x /= width;
    geometry.faceVertexUvs[0][faceIndex][i].y /= height;
  }
  // Right triangle
  for (let i = 0; i < 3; i++) {
    geometry.faceVertexUvs[0][faceIndex + 1][i].x /= width;
    geometry.faceVertexUvs[0][faceIndex + 1][i].y /= height;
  }
}
function buildFrameEdge(length, thickness, depth) {
  // build a shape to represent the frame edge with diagonal portions on the top and bottom
  const frameShape = new Shape();
  frameShape.moveTo(0, 0);
  frameShape.lineTo(thickness, thickness);
  frameShape.lineTo(thickness, length - thickness);
  frameShape.lineTo(0, length);
  // Extrude the edge into a geometry
  const frameGeometry = new ExtrudeGeometry(frameShape, {
    bevelEnabled: false,
    depth,
    curveSegments: 1
  });
  // front / back
  normalizeUvs(frameGeometry, 0, length, length);
  normalizeUvs(frameGeometry, 1, length, length);
  // left / right
  UVMapFace(frameGeometry, 3, 0, depth / length, 0, 1);
  UVMapFace(frameGeometry, 5, 0, depth / length, 0, 1);
  return frameGeometry;
}
export function buildFrame(dimensions, thickness, depth, padding, offset, uuid) {
  const meshes = [];
  // Total width and height accounting for thickness and padding
  const frameWidth = dimensions.width + thickness * 2 + padding * 2;
  const frameHeight = dimensions.height + thickness * 2 + padding * 2;
  // Make the vertical segments 1% deeper to have a visible diagonal on materials that don't show patterned textures
  const verticalGeometry = buildFrameEdge(frameHeight, thickness, depth * 1.01);
  const leftMesh = new Mesh(verticalGeometry);
  leftMesh.uuid = "".concat(uuid, "-left");
  leftMesh.position.setX(-dimensions.width * 0.5 - (thickness + padding));
  leftMesh.position.setY(-dimensions.height * 0.5 - (thickness + padding));
  leftMesh.position.setZ(-dimensions.depth * 0.5 - offset);
  const rightMesh = new Mesh(verticalGeometry);
  rightMesh.uuid = "".concat(uuid, "-right");
  rightMesh.rotateZ(Math.PI);
  rightMesh.position.setX(dimensions.width * 0.5 + (thickness + padding));
  rightMesh.position.setY(dimensions.height * 0.5 + (thickness + padding));
  rightMesh.position.setZ(-dimensions.depth * 0.5 - offset);
  meshes.push(leftMesh);
  meshes.push(rightMesh);
  const horizontalGeometry = buildFrameEdge(frameWidth, thickness, depth);
  const topMesh = new Mesh(horizontalGeometry);
  topMesh.uuid = "".concat(uuid, "-top");
  topMesh.rotateZ(Math.PI * 1.5);
  topMesh.position.setX(-dimensions.width * 0.5 - (thickness + padding));
  topMesh.position.setY(dimensions.height * 0.5 + (thickness + padding));
  topMesh.position.setZ(-dimensions.depth * 0.5 - offset);
  const bottomMesh = new Mesh(horizontalGeometry);
  bottomMesh.uuid = "".concat(uuid, "-bottom");
  bottomMesh.rotateZ(Math.PI * 0.5);
  bottomMesh.position.setX(dimensions.width * 0.5 + (thickness + padding));
  bottomMesh.position.setY(-dimensions.height * 0.5 - (thickness + padding));
  bottomMesh.position.setZ(-dimensions.depth * 0.5 - offset);
  meshes.push(topMesh);
  meshes.push(bottomMesh);
  return meshes;
}